angular.module('app')
    .directive('sharePopup', function() {
        return {
            templateUrl: 'components/directives/share_popup/view.share_popup.html',
            controller: 'SharePopupController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=',
                show: '=',
                type: '<',
                state: '<',
            }
        }
    });
